import { COMMON_TEXT } from '@/helpers/common-text';

// 1	employee_locations
// 2	room_availabilities
// 3	people_counts
// 4	performances
// 5	environments
// 6	meeting_rooms
// 7	deivce_status
// 8	meraki_logging
// 9	verkada_logging
// 10	employee_managements
// 11	people_counts_analysis
// 12 employee_attendance
// 13	signage_components
// 14	bcp_overview

export const CSV_DOWNLOAD_COMPONENT = {
  NETWORK_PERFORMANCE_SCORE: 1,
  WIRELESS_SIGNAL: 2,
  NETWORK_CLIENT_COUNT: 3,
  NETWORK_USAGE: 4,
  WIRELESS_CHANNEL_UTILIZATION: 5,
  WIRELESS_LATENCY: 6,
  MEETING_ROOM_OUTLOOK_TABLE: 7,
  SENSOR_DATA_HISTORY: 8,
  PEOPLE_COUNTS_ANALYSIS: 9,
};

export const PERFORMANCE_COMPONENT = {
  NETWORK_PERFORMANCE_SCORE: 1,
  WIRELESS_SIGNAL: 2,
  NETWORK_CLIENT_COUNT: 3,
  NETWORK_USAGE: 4,
  WIRELESS_CHANNEL_UTILIZATION: 5,
  WIRELESS_LATENCY: 6,
};

export const COMPONENT_ID_GROUP = {
  EMPLOYEE_LOCATIONS: 1,
  ROOM_AVAILABILITIES: 2,
  PEOPLE_COUNTS: 3,
  PERFORMANCES: 4,
  ENVIRONMENTS: 5,
  MEETING_ROOMS: 6,
  DEVICE_STATUS: 7,
  MERAKI_LOGGING: 8,
  VERKADA_LOGGING: 9,
  EMPLOYEE_MANAGEMENTS: 10,
  PEOPLE_COUNTS_ANALYSIS: 11,
  EMPLOYEE_ATTENDANCE: 12,
  SIGNAGE_COMPONENTS: 13,
  BCP_OVERVIEW: 14,
  CONFIGURATION: 999,
};

export const COMPONENT_CHILD_ID_GROUP = {
  TEMPERATURE: 1,
  HUMIDITY: 2,
  CARBON_DIOXIDE: 3,
  NOISE_LEVEL: 4,
};

export const NETWORK_SORT_OPTIONS = {
  DEVICE_NAME_ASC: 'device_name_asc',
  PERFORMANCE_SCORE_BAR_DESC: 'performance_score_bar_desc',
  PERFORMANCE_SCORE_BAR_ASC: 'performance_score_bar_asc',
};

export const CONFIGURATION_COMPONENT_INDEX = {
  TENANT_SETTING: 0,
  ORGANIZATION_SETTING: 1,
  LOCATION_SETTING: 2,
  FLOOR_SETTING: 3,
  VERKADA_DEVICE_SETTING: 4,
  DEVICE_LOCATION_SETTING: 5,
  CAMERA_ZONE_SETTING: 6,
  COMPANY_EMPLOYEE_SETTING: 7,
  EMPLOYEE_TERMINAL_SETTING: 8,
  MEETING_ROOM_ANALYSIS_SETTING: 9,
  WORKING_HOUR_SETTING: 10,
  AREA_SETTING: 11,
  AIR_QUALITY_SETTING: 12,
  ATTENDANCE_RATE_SETTING: 13,
  PEOPLE_COUNT_SETTING: 14,
  COMPANY_USER_SETTING: 15,
  AUDIT_WRITE_LOG: 16,
};

export const CONFIGURATION_COMPONENT_LIST = [
  {
    index: CONFIGURATION_COMPONENT_INDEX.TENANT_SETTING,
    name: COMMON_TEXT.TENANT_SETTING,
    component: 'TenantSetting',
    url: '/configuration/tenant-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.ORGANIZATION_SETTING,
    name: COMMON_TEXT.ORGANIZATION_SETTING,
    component: 'OrganizationSetting',
    url: '/configuration/organization-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.LOCATION_SETTING,
    name: COMMON_TEXT.LOCATION_SETTING,
    component: 'LocationSetting',
    url: '/configuration/location-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.FLOOR_SETTING,
    name: COMMON_TEXT.FLOOR_SETTING,
    component: 'FloorSetting',
    url: '/configuration/floor-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.AREA_SETTING,
    name: COMMON_TEXT.AREA_SETTING,
    component: 'AreaSetting',
    url: '/configuration/area-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.VERKADA_DEVICE_SETTING,
    name: COMMON_TEXT.VERKADA_DEVICE_SETTING,
    component: 'VerkadaDeviceSetting',
    url: '/configuration/verkada-device-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.DEVICE_LOCATION_SETTING,
    name: COMMON_TEXT.DEVICE_LOCATION_SETTING,
    component: 'DeviceLocationSetting',
    url: '/configuration/device-location-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.CAMERA_ZONE_SETTING,
    name: COMMON_TEXT.CAMERA_ZONE_SETTING,
    component: 'CameraZoneSetting',
    url: '/configuration/camera-zone-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.AIR_QUALITY_SETTING,
    name: COMMON_TEXT.AIR_QUALITY_SETTING,
    component: 'AirQualitySetting',
    url: '/configuration/air-quality-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.COMPANY_EMPLOYEE_SETTING,
    name: COMMON_TEXT.COMPANY_EMPLOYEE_SETTING,
    component: 'EmployeeSetting',
    url: '/configuration/employee-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.MEETING_ROOM_ANALYSIS_SETTING,
    name: COMMON_TEXT.MEETING_ROOM_ANALYSIS_SETTING,
    component: 'MeetingRoomAnalysisSetting',
    url: '/configuration/meeting-room-analysis-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.WORKING_HOUR_SETTING,
    name: COMMON_TEXT.WORKING_HOUR_SETTING,
    component: 'WorkingHourSetting',
    url: '/configuration/working-hour-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.ATTENDANCE_RATE_SETTING,
    name: COMMON_TEXT.EMPLOYEE_ATTENDANCE_RATE,
    component: 'AttendanceRateSetting',
    url: '/configuration/attendance-rate-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.PEOPLE_COUNT_SETTING,
    name: COMMON_TEXT.PEOPLE_COUNTS,
    component: 'PeopleCountSetting',
    url: '/configuration/people-count-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.COMPANY_USER_SETTING,
    name: COMMON_TEXT.COMPANY_USER_SETTING,
    component: 'UserSetting',
    url: '/configuration/user-setting',
  },
  {
    index: CONFIGURATION_COMPONENT_INDEX.AUDIT_WRITE_LOG,
    name: COMMON_TEXT.AUDIT_WRITE_LOG,
    component: 'AuditWriteLog',
    url: '/configuration/audit-write-log',
  },
];

export const PC_PHONE_TYPE = {
  PC: 'pc',
  PHONE: 'phone',
};
